import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnalysisReportEnterpriseComponent } from "./analysis-report-enterprise/analysis-report-enterprise.component";
import { AnalysisReportCustomerComponent } from "./analysis-report-customer/analysis-report-customer.component";
import { HighchartsChartModule } from 'highcharts-angular';
import { TranslateModule} from '@ngx-translate/core';
import { AnalysisReportUserNormalComponent } from './analysis-report-user-normal/analysis-report-user-normal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/core/material';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import {ModalMoneyTransferComponent} from './analysis-report-enterprise/modal-money-transfer/modal-money-transfer.component';

@NgModule({
    declarations: [
        AnalysisReportEnterpriseComponent,
        AnalysisReportCustomerComponent,
        AnalysisReportUserNormalComponent,
        ModalMoneyTransferComponent
    ],
    imports: [
        CommonModule,
        HighchartsChartModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgZorroAntdModule
    ],
    exports: [
    TranslateModule,
    AnalysisReportEnterpriseComponent,
    AnalysisReportCustomerComponent,
    AnalysisReportUserNormalComponent
  ],
  entryComponents: [
    ModalMoneyTransferComponent
  ]
  })
  export class AnalysisReportModule { }
